import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { addSpacesToTitleCase } from "common/helpers/utils";

const Container = styled(FormControl)(() => ({
  maxWidth: '100%',
  minWidth: '33%'
}));

type ProfileCategoriesSelectProps = {
  className?: string;
  categories: string[];
  options: string[];
  onChange: (updatedCategories: string[]) => void;
};

export default function TeamProfileCategoriesSelect(props: Readonly<ProfileCategoriesSelectProps>) {
  const { className, options } = props;
  return (
    <Container className={className}>
      <Autocomplete
        multiple
        options={options}
        getOptionLabel={(option) => addSpacesToTitleCase(option)}
        value={props.categories}
        onChange={(event, newValue) => props.onChange(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Profile Type(s)"
          />
        )}
      />
    </Container>
  );
}
